import { Col, Row } from "@intech/web-ui";
import styled from "styled-components";

export const CenteredCol = styled(Col)`
  justify-content: center;
  align-self: center;
`;

export const ResultadoRow = styled(Row)`
  border-bottom: 1px solid black;
  margin-top: 5px;
  padding-bottom: 5px;
`;

export const DepTable = styled.table`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1rem;
  color: #212529;
  border-collapse: collapse;
  font-size: 13px;
`;

export const TH = styled.th`
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  color: #7c7e80;
  border-collapse: collapse;
  text-align: left;
  ${props => `${props.style}`}
`;

export const TD = styled.td`
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  color: #212529;
  border-collapse: collapse;
  font-size: 11px;
  text-align: center;
`;

export const TR = styled.tr`
  &:nth-of-type(2n+1) {
    background-color: rgba(0,0,0,0.09);
  }
`;